import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import SampleCollectionsView from './SampleCollections.view';

// Container for the Logistics-facing sample-collection task queue.
// Backend endpoint enforces the auth gate + column allowlist; this component
// just fetches, hands rows to the view, and routes on row click.
export default function SampleCollections() {
  const navigate = useNavigate();
  const [tasks, setTasks]   = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get('/sample-collections');
      setTasks(Array.isArray(res.data?.tasks) ? res.data.tasks : []);
    } catch (err) {
      console.error('sample-collections load error:', err);
      toast.error(err.response?.data?.error || 'Failed to load collection tasks');
      setTasks([]);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SampleCollectionsView
      tasks={tasks}
      loading={loading}
      onReload={load}
      onRowClick={(id) => navigate(`/sample-collections/${id}`)}
    />
  );
}
